import { render } from "./PostComposer.vue?vue&type=template&id=7e5092e7&scoped=true"
import script from "./PostComposer.vue?vue&type=script&lang=js"
export * from "./PostComposer.vue?vue&type=script&lang=js"

import "./PostComposer.vue?vue&type=style&index=0&id=7e5092e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5092e7"]])

export default __exports__